import ProductsCard from "../cards/productscard"
import { ProductsData } from "../data/productsdata"
import { collection, doc, setDoc } from "firebase/firestore"
import { useEffect, useState } from "react"
import { db } from "../firebase/firebase"
import { Link } from "react-router-dom"
import ModalAgeAuthentication from "./modalageauthentication"
import { useFormik } from "formik";
import * as Yup from "yup";


const Products = ({sortedProducts, mockProd, verified, setVerified, setMocktails, mocktails, addEmail, setAddEmail}) =>  {  
    const [products, setProducts] =  useState([])
    // const [submitted, setSubmitted] = useState(false)
    const [email, setEmail] =  useState("")

    useEffect(() => {
        if (mocktails) {
            setProducts(mockProd)
        } else {
            setProducts(sortedProducts)
        }
    }, [mocktails])


    // const joinUpdates = async () => {
    //     const emailRef = doc(collection(db, "emails"))
    //     try{
    //         setSubmitted(true)
    //         await setDoc(emailRef, {
    //             email
    //         })
    //         setEmail("")
    //     } catch (e) {
    //         console.log(e)
    //     }
    // }

    const joinUpdates = async (values) => {
        const emailRef = doc(collection(db, "emails"))
        setAddEmail(true)
        try{
            await setDoc(emailRef, {
                values
            })
        } catch (e) {
            console.log(e)
        }
    }

const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
        setAddEmail(true)
        joinUpdates(values.email)
        console.log(values.email)
    },
  });

    

    return (
        <section className="mt-5">
            <div className="container">
                <div className="mb-5">
                    <h1 className="tt-header-fs fw-bolder text-center">OUR <span>{mocktails ? "MOCKTAILS" : "COCKTAILS"}</span></h1>
                                <h5 className=" fw-bold pt-3 text-center"  >
                                    View our {mocktails ? "cocktails" : "mocktails"} here
                                    { verified ? 
                                        <Link to="/products" >
                                            <button className="ms-3 tt-button btn bi bi-arrow-right"
                                                    onClick={() => setMocktails(!mocktails)}
                                            >
                                            </button>
                                        </Link> 
                                        :
                                        <button className="ms-3 tt-button btn bi bi-arrow-right"
                                                data-bs-toggle="modal" 
                                                data-bs-target="#ageAuthentication"
                                                // onClick={() => {
                                                
                                                // }}
                                        >
                                        </button>
                                    }
                                </h5>

                </div>
                <div className="row row-cols-xl-3  row-cols-2 gy-5 justify-content-center">
                    {products
                        .filter(product => !product.hidden)
                        .map((product, index)=> (
                        <ProductsCard key={product.id} product={product} mocktails={mocktails}/>
                        ))}
                        <div className="col-lg-8 col-12">
                            <div className="tt-more-to-come w-100 d-flex justify-content-center align-items-center">
                                {/* {submitted ? 
                                    <div className="border border-dark rounded-2 p-0 p-md-5 py-5 px-1 border-2 h-100 d-flex flex-column  align-items-center justify-content-center">
                                            <h2 className="fw-bold text-center mb-4">You have signed up for our updates!</h2>
                                        </div>:
                                        <div className="border border-dark rounded-2 p-0 p-md-5 py-5 px-1 border-2 h-100 d-flex flex-column  align-items-center justify-content-center">
                                            <h2 className="fw-bold text-center mb-4">MORE TO COME SOON...</h2>
                                            <div className="mt-5 d-flex flex-column  w-100 justify-content-evenly" >
                                                <button className="btn bg-dark text-white mb-3 " onClick={() => joinUpdates()}>Stay Updated</button>
                                                <input className="border-0 border-bottom border-2 bg-white text-center" type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)}/>
                                            </div>
                                        </div>} */}
                                {addEmail ? 
                                    <div className="border border-dark rounded-2 p-0 p-md-5 py-5 px-1 border-2 h-100 d-flex flex-column  align-items-center justify-content-center">
                                            <h2 className="fw-bold text-center mb-4">You have signed up for our updates!</h2>
                                        </div>:
                                        <div className="border border-dark rounded-2 p-0 p-md-5 py-5 px-1 border-2 h-100 d-flex flex-column  align-items-center justify-content-center">
                                            <h2 className="fw-bold text-center mb-4">MORE TO COME SOON...</h2>
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="mt-5 d-flex flex-column  w-100 justify-content-evenly">
                                            <button className="btn bg-dark text-white mb-3" type="submit" >Stay Updated</button>
                                            <input
                                            className="border-0 border-bottom border-2 bg-white text-center"
                                            placeholder="Email Address"
                                            id="email"
                                            name="email"
                                            type="email"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            />
                                        </div>
                                    </form>
                                        </div>}
                        </div>
                    </div>
                </div>
            </div>
            <ModalAgeAuthentication setVerified={setVerified}/>
        </section>
    )
}



export default Products